import { Toast } from 'primereact/toast';
import { useRef, useEffect } from 'react';

export const toastRef = { current: null as Toast | null };

const GlobalToast = () => {
  const localRef = useRef<Toast>(null);

  useEffect(() => {
    toastRef.current = localRef.current;
  }, []);

  return <Toast ref={localRef} position="top-right" />;
};

export default GlobalToast;
